export const debugMode = !!localStorage.getItem("debug") || false;
